<template>
    <span>
        <a-button v-if="!$userIsInrol('Query') && !$userIsInrol('NoCreacionContratos')"  v-on:click.prevent="showModal">Crear contrato</a-button>
        <a-modal title="Crear Contrato"
                 :visible="modalVisible"
                 width="70%"
                 @ok="confirmar"
                 :confirmLoading="modalLoading"
                 @cancel="cancelar">
          <a-form-model layout="vertical" :model="iEmployee" :rules="formRules"
                        @submit="confirmar"
                        @submit.native.prevent ref="formContrato">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('ID empleado')" prop="name" has-feedback>
                  <a-input style="width: 100%"
                           class="ant-uppercase"
                           v-model="iEmployee.id_emp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Compañía')" prop="company" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="company"
                                       v-model="iEmployee.company"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Cargo')" prop="job" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       v-model="iEmployee.job"
                                       endpoint="jobs"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Oficina')" prop="location" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="offices"
                                       v-model="iEmployee.location">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tipo pago')" prop="tpay" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.tpay"
                                         endpoint="hierarchy_lookup"
                                         :params="tpay"
                    ></form-model-dropdown>
                  </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tipo de contrato')" prop="id_h_contract_type" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       v-model="iEmployee.id_h_contract_type"
                                       endpoint="hierarchy_lookup"
                                       :params="tipoContrato"
                                       :selectedObj.sync="tipoDeContrato"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Fecha inicio contrato')" prop="initial_date" has-feedback>
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD 00:00:00"
                                 v-model="iEmployee.initial_date"
                  />
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan" v-show="visibleFF">
                <a-form-model-item :label="$t('Fecha fin contrato')" prop="end_date" has-feedback>
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD 00:00:00"
                                 v-model="iEmployee.end_date"
                  />
                </a-form-model-item>
              </a-col>
              <a-alert type="error" :message="mensajeError" v-if="error"/>
            </a-row>
          </a-form-model>
        </a-modal>
    </span>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['id_person'],
    data () {
      return {
        visibleFF: true,
        tipoDeContrato: {},
        tipoContrato: {h_lookup_type: 'TIPO_CONTRATO'},
        tpay: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        colSpan: {
          xs: 24,
          md: 12
        },
        formRules: {},
        iEmployee: {},
        modalVisible: false,
        modalLoading: false,
        error: false
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.iEmployee.id_emp = this.id_person
      this.initFormRules()
    },
    watch: {
      id_person () {
        this.iEmployee.id_person = this.id_person
      },
      tipoDeContrato () {
        if (this.tipoDeContrato.code === 'I' || this.tipoDeContrato.code === 'TI' ||
          this.tipoDeContrato.code === 'OBR' // CODE contrato DURACION DE LA OBRA de IYCSA
        ) {
          this.initFormRules(false)
          this.visibleFF = false
        } else {
          this.visibleFF = true
          this.initFormRules(true)
        }
      }
    },
    methods: {
      initFormRules (endValue = true) {
        if (this.$getConfigValue('MASIVO_FECHA_FIN_CONTRATO_REQUERIDA', 'SI') === 'NO') {
          endValue = false
        }
        this.formRules = {
          company: [{
            required: true,
            message: 'Valor requerido'
          }],
          job: [{
            required: true,
            message: 'Valor requerido'
          }],
          location: [{
            required: true,
            message: 'Valor requerido'
          }],
          initial_date: [{
            required: true,
            message: 'Valor requerido'
          }],
          tpay: [{
            required: true,
            message: 'Valor requerido'
          }],
          end_date: [{
            required: endValue,
            message: 'Valor requerido'
          }]
        }
      },
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.modalLoading = false
      },
      confirmar () {
        this.$refs.formContrato.validate(valid => {
          if (valid) {
            this.loading = true
            this.modalLoading = true
            this.iEmployee.id_person = this.id_person
            this.iEmployee.crear_contrato = true
            let req = {...this.iEmployee}
            this.httpClient.getInstance().post('employee/guardardatoslaborales', req)
              .then(() => {
                this.modalLoading = false
                this.$emit('success')
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch((error) => {
                let errorstr = this.$getErrorMessage(error, 'No fue posible crear el contrato')
                let exists = errorstr.includes('YA EXISTE UN CONTRATO ACTIVO PARA ESTE EMPLEADO')
                if (exists) {
                  Mensajes.error('Error', 'YA EXISTE UN CONTRATO ACTIVO PARA ESTE EMPLEADO')
                } else {
                  Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible crear el contrato'))
                }
              })
              .then(() => {
                this.loading = false
                this.modalVisible = false
                this.modalLoading = false
                this.iEmployee = {}
              })
          }
        })
      },
      showModal () {
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/btnCrearContrato.vue